/* Storefront interactions: mobile drawer, drawer tabs, accordions. */
(function () {
  var btn = document.getElementById('navToggle');
  var drawer = document.getElementById('mobileDrawer');
  var overlay = document.getElementById('drawerOverlay');
  var close = document.getElementById('drawerClose');

  function open() {
    if (!drawer) return;
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function shut() {
    if (!drawer) return;
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (btn) btn.addEventListener('click', open);
  if (close) close.addEventListener('click', shut);
  if (overlay) overlay.addEventListener('click', shut);

  document.querySelectorAll('.drawer-tab').forEach(function (t) {
    t.addEventListener('click', function () {
      document.querySelectorAll('.drawer-tab').forEach(function (x) { x.classList.remove('active'); });
      document.querySelectorAll('.drawer-panel').forEach(function (x) { x.classList.remove('active'); });
      t.classList.add('active');
      var panel = document.getElementById('panel-' + t.dataset.tab);
      if (panel) panel.classList.add('active');
    });
  });

  document.querySelectorAll('.drawer-acc').forEach(function (a) {
    a.addEventListener('click', function () {
      a.classList.toggle('open');
      var sub = document.getElementById('acc-' + a.dataset.acc);
      if (sub) sub.classList.toggle('open');
    });
  });
})();
